/* sucrase/dist/esm/parser/plugins/jsx/index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.jsxParseElement = jsxParseElement;
    exports.nextJSXTagToken = nextJSXTagToken;
    const index_1 = require("bfb18d0576") /* ../../tokenizer/index */;
    const types_1 = require("f0c35cbd76") /* ../../tokenizer/types */;
    const base_1 = require("540718e523") /* ../../traverser/base */;
    const expression_1 = require("8178e7c3c8") /* ../../traverser/expression */;
    const util_1 = require("bc94bbadc1") /* ../../traverser/util */;
    const charcodes_1 = require("22746c8ce8") /* ../../util/charcodes */;
    const identifier_1 = require("364148c9f0") /* ../../util/identifier */;
    const typescript_1 = require("6a970c22b9") /* ../typescript */;
    /**
     * Read token with JSX contents.
     *
     * In addition to detecting jsxTagStart and also regular tokens that might be
     * part of an expression, this code detects the start and end of text ranges
     * within JSX children. In order to properly count the number of children, we
     * distinguish jsxText from jsxEmptyText, which is a text range that simplifies
     * to the empty string after JSX whitespace trimming.
     *
     * It turns out that a JSX text range will simplify to the empty string if and
     * only if both of these conditions hold:
     * - The range consists entirely of whitespace characters (only counting space,
     *   tab, \r, and \n).
     * - The range has at least one newline.
     * This can be proven by analyzing any implementation of whitespace trimming,
     * e.g. formatJSXTextLiteral in Sucrase or cleanJSXElementLiteralChild in Babel.
     */
    function jsxReadToken() {
        let sawNewline = false;
        let sawNonWhitespace = false;
        while (true) {
            if (base_1.state.pos >= base_1.input.length) {
                (0, util_1.unexpected)("Unterminated JSX contents");
                return;
            }
            const ch = base_1.input.charCodeAt(base_1.state.pos);
            if (ch === charcodes_1.charCodes.lessThan || ch === charcodes_1.charCodes.leftCurlyBrace) {
                if (base_1.state.pos === base_1.state.start) {
                    if (ch === charcodes_1.charCodes.lessThan) {
                        base_1.state.pos++;
                        (0, index_1.finishToken)(types_1.TokenType.jsxTagStart);
                        return;
                    }
                    (0, index_1.getTokenFromCode)(ch);
                    return;
                }
                if (sawNewline && !sawNonWhitespace) {
                    (0, index_1.finishToken)(types_1.TokenType.jsxEmptyText);
                }
                else {
                    (0, index_1.finishToken)(types_1.TokenType.jsxText);
                }
                return;
            }
            // This is part of JSX text.
            if (ch === charcodes_1.charCodes.lineFeed) {
                sawNewline = true;
            }
            else if (ch !== charcodes_1.charCodes.space && ch !== charcodes_1.charCodes.carriageReturn && ch !== charcodes_1.charCodes.tab) {
                sawNonWhitespace = true;
            }
            base_1.state.pos++;
        }
    }
    function jsxReadString(quote) {
        base_1.state.pos++;
        for (;;) {
            if (base_1.state.pos >= base_1.input.length) {
                (0, util_1.unexpected)("Unterminated string constant");
                return;
            }
            const ch = base_1.input.charCodeAt(base_1.state.pos);
            if (ch === quote) {
                base_1.state.pos++;
                break;
            }
            base_1.state.pos++;
        }
        (0, index_1.finishToken)(types_1.TokenType.string);
    }
    // Read a JSX identifier (valid tag or attribute name).
    //
    // Optimized version since JSX identifiers can't contain
    // escape characters and so can be read as single slice.
    // Also assumes that first character was already checked
    // by isIdentifierStart in readToken.
    function jsxReadWord() {
        let ch;
        do {
            if (base_1.state.pos > base_1.input.length) {
                (0, util_1.unexpected)("Unexpectedly reached the end of input.");
                return;
            }
            ch = base_1.input.charCodeAt(++base_1.state.pos);
        } while (identifier_1.IS_IDENTIFIER_CHAR[ch] || ch === charcodes_1.charCodes.dash);
        (0, index_1.finishToken)(types_1.TokenType.jsxName);
    }
    // Parse next token as JSX identifier
    function jsxParseIdentifier() {
        nextJSXTagToken();
    }
    // Parse namespaced identifier.
    function jsxParseNamespacedName(identifierRole) {
        jsxParseIdentifier();
        if (!(0, index_1.eat)(types_1.TokenType.colon)) {
            // Plain identifier, so this is an access.
            base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = identifierRole;
            return;
        }
        // Process the second half of the namespaced name.
        jsxParseIdentifier();
    }
    // Parses element name in any form - namespaced, member
    // or single identifier.
    function jsxParseElementName() {
        const firstTokenIndex = base_1.state.tokens.length;
        jsxParseNamespacedName(index_1.IdentifierRole.Access);
        let hadDot = false;
        while ((0, index_1.match)(types_1.TokenType.dot)) {
            hadDot = true;
            nextJSXTagToken();
            jsxParseIdentifier();
        }
        // For tags like <div> with a lowercase letter and no dots, the name is
        // actually *not* an identifier access, since it's referring to a built-in
        // tag name. Remove the identifier role in this case so that it's not
        // accidentally transformed by the imports transform when preserving JSX.
        if (!hadDot) {
            const firstToken = base_1.state.tokens[firstTokenIndex];
            const firstChar = base_1.input.charCodeAt(firstToken.start);
            if (firstChar >= charcodes_1.charCodes.lowercaseA && firstChar <= charcodes_1.charCodes.lowercaseZ) {
                firstToken.identifierRole = null;
            }
        }
    }
    // Parses any type of JSX attribute value.
    function jsxParseAttributeValue() {
        switch (base_1.state.type) {
            case types_1.TokenType.braceL:
                (0, index_1.next)();
                (0, expression_1.parseExpression)();
                nextJSXTagToken();
                return;
            case types_1.TokenType.jsxTagStart:
                jsxParseElement();
                nextJSXTagToken();
                return;
            case types_1.TokenType.string:
                nextJSXTagToken();
                return;
            default:
                (0, util_1.unexpected)("JSX value should be either an expression or a quoted JSX text");
        }
    }
    // Parse JSX spread child, after already processing the {
    // Does not parse the closing }
    function jsxParseSpreadChild() {
        (0, util_1.expect)(types_1.TokenType.ellipsis);
        (0, expression_1.parseExpression)();
    }
    // Parses JSX opening tag starting after "<".
    // Returns true if the tag was self-closing.
    // Does not parse the last token.
    function jsxParseOpeningElement(initialTokenIndex) {
        if ((0, index_1.match)(types_1.TokenType.jsxTagEnd)) {
            // This is an open-fragment.
            return false;
        }
        jsxParseElementName();
        if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsTryParseJSXTypeArgument)();
        }
        let hasSeenPropSpread = false;
        while (!(0, index_1.match)(types_1.TokenType.slash) && !(0, index_1.match)(types_1.TokenType.jsxTagEnd) && !base_1.state.error) {
            if ((0, index_1.eat)(types_1.TokenType.braceL)) {
                hasSeenPropSpread = true;
                (0, util_1.expect)(types_1.TokenType.ellipsis);
                (0, expression_1.parseMaybeAssign)();
                // }
                nextJSXTagToken();
                continue;
            }
            if (hasSeenPropSpread &&
                base_1.state.end - base_1.state.start === 3 &&
                base_1.input.charCodeAt(base_1.state.start) === charcodes_1.charCodes.lowercaseK &&
                base_1.input.charCodeAt(base_1.state.start + 1) === charcodes_1.charCodes.lowercaseE &&
                base_1.input.charCodeAt(base_1.state.start + 2) === charcodes_1.charCodes.lowercaseY) {
                base_1.state.tokens[initialTokenIndex].jsxRole = index_1.JSXRole.KeyAfterPropSpread;
            }
            jsxParseNamespacedName(index_1.IdentifierRole.ObjectKey);
            if ((0, index_1.match)(types_1.TokenType.eq)) {
                nextJSXTagToken();
                jsxParseAttributeValue();
            }
        }
        const isSelfClosing = (0, index_1.match)(types_1.TokenType.slash);
        if (isSelfClosing) {
            // /
            nextJSXTagToken();
        }
        return isSelfClosing;
    }
    // Parses JSX closing tag starting after "</".
    // Does not parse the last token.
    function jsxParseClosingElement() {
        if ((0, index_1.match)(types_1.TokenType.jsxTagEnd)) {
            // Fragment syntax, so we immediately have a tag end.
            return;
        }
        jsxParseElementName();
    }
    // Parses entire JSX element, including its opening tag
    // (starting after "<"), attributes, contents and closing tag.
    // Does not parse the last token.
    function jsxParseElementAt() {
        const initialTokenIndex = base_1.state.tokens.length - 1;
        base_1.state.tokens[initialTokenIndex].jsxRole = index_1.JSXRole.NoChildren;
        let numExplicitChildren = 0;
        const isSelfClosing = jsxParseOpeningElement(initialTokenIndex);
        if (!isSelfClosing) {
            nextJSXExprToken();
            while (true) {
                switch (base_1.state.type) {
                    case types_1.TokenType.jsxTagStart:
                        nextJSXTagToken();
                        if ((0, index_1.match)(types_1.TokenType.slash)) {
                            nextJSXTagToken();
                            jsxParseClosingElement();
                            // Key after prop spread takes precedence over number of children,
                            // since it means we switch to createElement, which doesn't care
                            // about number of children.
                            if (base_1.state.tokens[initialTokenIndex].jsxRole !== index_1.JSXRole.KeyAfterPropSpread) {
                                if (numExplicitChildren === 1) {
                                    base_1.state.tokens[initialTokenIndex].jsxRole = index_1.JSXRole.OneChild;
                                }
                                else if (numExplicitChildren > 1) {
                                    base_1.state.tokens[initialTokenIndex].jsxRole = index_1.JSXRole.StaticChildren;
                                }
                            }
                            return;
                        }
                        numExplicitChildren++;
                        jsxParseElementAt();
                        nextJSXExprToken();
                        break;
                    case types_1.TokenType.jsxText:
                        numExplicitChildren++;
                        nextJSXExprToken();
                        break;
                    case types_1.TokenType.jsxEmptyText:
                        nextJSXExprToken();
                        break;
                    case types_1.TokenType.braceL:
                        (0, index_1.next)();
                        if ((0, index_1.match)(types_1.TokenType.ellipsis)) {
                            jsxParseSpreadChild();
                            nextJSXExprToken();
                            // Spread children are a mechanism to explicitly mark children as
                            // static, so count it as 2 children to satisfy the "more than one
                            // child" condition.
                            numExplicitChildren += 2;
                        }
                        else {
                            // If we see {}, this is an empty pseudo-expression that doesn't
                            // count as a child.
                            if (!(0, index_1.match)(types_1.TokenType.braceR)) {
                                numExplicitChildren++;
                                (0, expression_1.parseExpression)();
                            }
                            nextJSXExprToken();
                        }
                        break;
                    // istanbul ignore next - should never happen
                    default:
                        (0, util_1.unexpected)();
                        return;
                }
            }
        }
    }
    // Parses entire JSX element from current position.
    // Does not parse the last token.
    function jsxParseElement() {
        nextJSXTagToken();
        jsxParseElementAt();
    }
    // ==================================
    // Overrides
    // ==================================
    function nextJSXTagToken() {
        base_1.state.tokens.push(new index_1.Token());
        (0, index_1.skipSpace)();
        base_1.state.start = base_1.state.pos;
        const code = base_1.input.charCodeAt(base_1.state.pos);
        if (identifier_1.IS_IDENTIFIER_START[code]) {
            jsxReadWord();
        }
        else if (code === charcodes_1.charCodes.quotationMark || code === charcodes_1.charCodes.apostrophe) {
            jsxReadString(code);
        }
        else {
            // The following tokens are just one character each.
            ++base_1.state.pos;
            switch (code) {
                case charcodes_1.charCodes.greaterThan:
                    (0, index_1.finishToken)(types_1.TokenType.jsxTagEnd);
                    break;
                case charcodes_1.charCodes.lessThan:
                    (0, index_1.finishToken)(types_1.TokenType.jsxTagStart);
                    break;
                case charcodes_1.charCodes.slash:
                    (0, index_1.finishToken)(types_1.TokenType.slash);
                    break;
                case charcodes_1.charCodes.equalsTo:
                    (0, index_1.finishToken)(types_1.TokenType.eq);
                    break;
                case charcodes_1.charCodes.leftCurlyBrace:
                    (0, index_1.finishToken)(types_1.TokenType.braceL);
                    break;
                case charcodes_1.charCodes.dot:
                    (0, index_1.finishToken)(types_1.TokenType.dot);
                    break;
                case charcodes_1.charCodes.colon:
                    (0, index_1.finishToken)(types_1.TokenType.colon);
                    break;
                default:
                    (0, util_1.unexpected)();
            }
        }
    }
    function nextJSXExprToken() {
        base_1.state.tokens.push(new index_1.Token());
        base_1.state.start = base_1.state.pos;
        jsxReadToken();
    }
}
